// extracted by mini-css-extract-plugin
export default {"category":"Category_category__v9p+s","headerPage":"Category_headerPage__WBqg-","mainUl":"Category_mainUl__rg1ax","divPage":"Category_divPage__VlS8D"};